module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b4MbS"))).then(() => parcelRequire('3a9aZ'));